import {
  AccessControl,
  AppContext,
  isAuthorised,
  Loader,
  getTranslatedText,
  NoDataCard,
  COLOR_MAP,
  Splitter,
  BackgroundIcon,
  toast,
  getDownloadURL,
  getConversationOrder,
  reactbellchatScrollBottom,
  reactbellchatScrollTop
} from '@nile/components';
import { useMutation, useQuery } from '@apollo/client';
import { ActionContainer } from '@nile/mangifera/src/Containers/ChatContainers';
import {
  ConversationBubble,
  TaskBubble,
  MilestoneBubble
} from '@nile/projects/src/Components/Chat';
import {
  SideConversationNotificationBubble,
  NoteBubble
} from '@nile/mangifera/src/Components/Chat';
import React, { useState, useEffect, useContext, useRef } from 'react';
import styled from 'styled-components';
import { ChatFeed } from 'react-bell-chat';
import { injectIntl, FormattedMessage } from 'react-intl';
import ProjectContext from '@nile/projects/src/Contexts/ProjectContext';
import envConfig from '@nile/home/src/Config/env';
import { Button } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { cloneDeep, isEmpty } from 'lodash';
import { GET_ROLE_PERMISSON } from '@nile/banyan/src/Graphql/Mutations/role';
import { AccountClient } from '@nile/graphql';

export const FeedWrap = styled.div`
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;

export const EmptyStateHolder = styled.div`
  height: calc(100% - 108px);
`;

export const StyledConversation = styled.div`
  border-bottom: 1px solid #e7e7e7;
  background-image: url(${envConfig.imageRoot}svg/chatBg.svg);
  background-size: 360px;
  background-color: var(--sops-ticket-coversation-bg);
  .react-bell-chat__chat-scroll-area {
    //scroll-behavior: smooth;
  }
  .react-bell-chat__chat-panel {
    height: calc(100% - 108px); //action container height with margin
    overflow: auto;
  }

  .rdw-editor-main {
    max-height: 200px;
    overflow: auto;
    margin: 10px;
    padding: 0 !important;
  }
  img {
    max-width: 100%;
  }
  .bubbleContainer {
    margin-bottom: 30px !important;

    code {
      white-space: pre-wrap;
    }

    table {
      width: 100% !important;
      max-width: 100% !important;
    }
    word-wrap: break-word;
  }
`;

const ActionToolbarContainer = styled.div`
  width: 95%;
  padding: 16px 0;
  // max-width: 720px;
  max-width: calc(100% - 60px);
  border-radius: 30px;
  background: #ffffff;
  margin: 14px auto;
  border: 1px solid #ececec;
  justify-content: space-evenly;
  .Superops-Button__Text {
    margin-left: 10px !important;
  }
`;

const ProjectFeedsContainer = (props) => {
  const appContext = useContext(AppContext);
  const projectContext = useContext(ProjectContext);
  const currentUser = appContext.user || {};
  const isMSP = currentUser?.accountType === 'MSP';
  const [roleFeaturesList, setRoleFeaturesList] = useState(
    appContext.user?.role?.roleFeatureList || []
  );
  const RoleId = props.project?.loggedInUserRole?.roleId;
  const workItem = { workId: props?.project?.projectId, module: 'PROJECT' };

  useQuery(GET_ROLE_PERMISSON, {
    variables: { roleId: RoleId },
    client: AccountClient,
    skip: !RoleId,
    onCompleted({ getRolePermissions }) {
      const updatedFeatures = cloneDeep(roleFeaturesList);
      if (getRolePermissions?.roleFeatureList?.length) {
        getRolePermissions.roleFeatureList.forEach((role) => {
          const idx = updatedFeatures.findIndex(
            (feat) => feat.feature.key === role.feature.key
          );
          if (idx >= 0) {
            updatedFeatures[idx] = role;
          } else {
            updatedFeatures.push(role);
          }
        });
      }
      setRoleFeaturesList(updatedFeatures);
    }
  });

  const isEditAuthorised = isAuthorised(roleFeaturesList, 'comments.add');
  const { user } = appContext;
  const [allFeeds, setAllFeeds] = useState(props.feeds || []);
  const { ticket, actions, feeds, intl } = props;

  useEffect(() => {
    setAllFeeds(props.feeds);
  }, [props.feeds]);

  if (props.loading) {
    return (
      <div className="full-height full-width flex actr jctr">
        <Loader />
      </div>
    );
  }

  const handleCommentSubmission = (editorObject, clearState) => {
    const chat = {
      content: editorObject.message,
      mentions: editorObject.mentions,
      attachments: editorObject.attachments?.map(
        ({ fileName, originalFileName, fileSize }) => {
          return { fileName, originalFileName, fileSize };
        }
      ),
      inlineImages: editorObject.inlineImages
    };
    props.actions
      .saveProjectComment({
        variables: { projectId: props.project.projectId, input: chat },
        input: { projectId: props.project.projectId, input: chat }
      })
      .then((res) => {
        if (res?.data?.addProjectComment) {
          clearState(true);
        }
      });
  };

  const handleNoteSubmission = (editorObject, clearState) => {
    const chat = {
      content: editorObject.message,
      mentions: editorObject.mentions,
      addAttachments: editorObject.attachments?.map(
        ({ fileName, originalFileName, fileSize }) => {
          return { fileName, originalFileName, fileSize };
        }
      ),
      inlineImages: editorObject.inlineImages,
      workItem: workItem,
      privacyType: editorObject.privacyType
    };
    props.actions
      .saveProjectNote({
        variables: { input: chat }
      })
      .then((res) => {
        if (res?.data?.createNote) {
          clearState(true);
        }
      });
  };

  const authors = [];
  const typeKey = {
    NOTE: 'note',
    CONVERSATION: 'conversation',
    VENDOR_CONVERSATION: 'vendorConversation',
    TASK: 'task',
    APPROVAL: 'approval'
  };
  const userKey = {
    note: 'addedBy',
    conversation: 'addedBy',
    vendorConversation: 'user',
    task: 'technician',
    approval: 'approver'
  };
  const timeKey = {
    conversation: 'addedOn',
    vendorConversation: 'time',
    note: 'addedOn',
    approval: 'sentOn'
  };
  const msgKey = {
    note: 'content',
    conversation: 'content',
    vendorConversation: 'content',
    task: 'title',
    milestone: 'name'
  };
  const messageTypeKey = {
    conversation: 'type',
    vendorConversation: 'type',
    note: 'type',
    approval: 'status',
    task: 'type',
    milestone: 'type'
  };

  // filter private notes for client portal.
  // Once backend fixes this, we can remove the below code.
  const filteredFeeds = allFeeds.filter((el) => {
    if (el.type === 'VENDOR_CONVERSATION') {
      if (el.vendorConversation.parentConversationId === null) return true;
      return el.vendorConversation.type === 'VENDOR_EMAIL';
    }
    return true;
  });

  const data =
    filteredFeeds.length > 0
      ? filteredFeeds.map((feed, idx) => {
          const feedType = typeKey[feed.type] || feed.type.toLowerCase();
          const currUser = feed[feedType][userKey[feedType]];
          if (
            currUser &&
            !authors.some((el) => el.authorId === currUser.userId)
          ) {
            authors.push({
              name: `${currUser.firstName} ${currUser.lastName}`,
              authorId: currUser.userId
            });
          }
          return {
            message: feed[feedType][msgKey[feedType]],
            attachments: feed[feedType]?.attachments,
            isSend: false,
            id: feed[feedType][`${feedType}Id`],
            authorId: currUser?.userId || '123',
            type: feedType,
            messageType: feed[feedType]?.[messageTypeKey[feedType]],
            user: currUser,
            time: feed.time,
            status: feed[feedType]?.status,
            data: feed[feedType],
            project: props.project,
            setProject: props.setProject
          };
        })
      : [];
  return (
    <StyledConversation
      className={`full-height scroll
        ${
          isAuthorised(projectContext.features, 'comments.add')
            ? ''
            : ' no-access'
        }`}
    >
      <FeedList
        data={data}
        authors={authors}
        user={user}
        handleCommentSubmission={handleCommentSubmission}
        handleNoteSubmission={handleNoteSubmission}
        isEditAuthorised={isEditAuthorised}
        workItem={workItem}
        {...props}
      />
    </StyledConversation>
  );
};

const CustomBubble = (props) => {
  const { message } = props;

  const getAttachmentURL = (msg, item) => {
    const { workItem } = props;
    const module = 'NOTE_ATTACHMENT';
    const details = {
      fileName: item?.fileName,
      note: {
        noteId: msg?.id,
        workItem: workItem
      }
    };
    const url = getDownloadURL({ module, details });
    return url;
  };

  const bubbles = {
    note: (
      <NoteBubble
        {...props}
        showPrivacyType
        module="NOTE"
        details={{ workItem: props?.workItem }}
        uploadParams={{
          module: 'NOTE_ATTACHMENT',
          details: JSON.stringify({ workItem: props?.workItem })
        }}
        getAttachmentURL={getAttachmentURL}
        allowEditDeleteNotes
        disableSpit
      />
    ),
    conversation: <ConversationBubble {...props} />,
    vendorConversation: <SideConversationNotificationBubble {...props} />,
    task: <TaskBubble {...props} />,
    milestone: <MilestoneBubble {...props} />
  };
  return <div className="bubbleContainer">{bubbles[message.type]}</div>;
};

function ActionToolbar(props) {
  const { onClick, isEditAuthorised, createNewSideConversation } = props;
  return (
    <ActionToolbarContainer>
      <div className="fx jspeven" id="actionToolbarHolder">
        {createNewSideConversation && (
          <>
            <div>{createNewSideConversation()}</div>
            <Splitter className="ml-12" color={COLOR_MAP.grey} />
          </>
        )}
        <div className="fx center ml-12">
          <Button
            plain
            onClick={() => onClick('note')}
            icon={
              <SVGIcon name="Notes" color={COLOR_MAP.blue} />
              // <BackgroundIcon
              //   color={COLOR_MAP.blue}
              //   url={`url(${envConfig.imageRoot}svg/notes.svg)`}
              // />
            }
            disabled={!isEditAuthorised}
          >
            <FormattedMessage id="workItem.details.add.note" />
          </Button>
        </div>
        <Splitter className="ml-12" color={COLOR_MAP.grey} />
        <div id="conversationReplyBtn" className="fx center ml-12">
          <Button
            plain
            onClick={() => onClick('conversation')}
            icon={<SVGIcon name="Reply" color={COLOR_MAP.blue} />}
            customClassName="replyBtn"
            disabled={!isEditAuthorised}
          >
            <FormattedMessage id="common.conversation.reply" />
          </Button>
        </div>
      </div>
    </ActionToolbarContainer>
  );
}

const FeedList = (props) => {
  const {
    user,
    authors,
    data: feeds,
    intl,
    switchToConnect,
    handleCommentSubmission,
    handleNoteSubmission,
    isEditAuthorised
  } = props;
  const chatFeedRef = useRef();
  const projectContext = useContext(ProjectContext);
  const [editor, setEditor] = useState('');
  const [editMode, setEditMode] = useState(false);

  const projectChatFeedRef = useRef();
  // value from user preferred conversation order
  const conversationOrder = getConversationOrder() || 'ASC';
  useEffect(() => {
    if (feeds.length > 0) {
      if (conversationOrder === 'ASC') {
        reactbellchatScrollBottom(projectChatFeedRef);
      } else {
        reactbellchatScrollTop(projectChatFeedRef);
      }
    }
  }, [feeds]);

  const getEmptyState = () => {
    return (
      <NoDataCard
        imageURL={`url(${envConfig.imageRoot}svg/updates-empty-state.svg)`}
        text={<FormattedMessage id="project.details.updates.emptyState" />}
        description={
          <FormattedMessage id="project.details.updates.emptyState.description" />
        }
        type="secondary"
      />
    );
  };

  const scrollIntoView = () => {
    setTimeout(() => {
      chatFeedRef.current.scrollTop = chatFeedRef.current.scrollHeight;
    }, 200);
  };

  const toggleToolbar = (type) => {
    setEditMode(type);
    scrollIntoView();
  };

  const ComposeSection = () => {
    switch (editMode) {
      case 'note':
        return (
          <AccessControl
            reference={projectContext.features}
            roleToCheck="comments.add"
            render={
              <ActionContainer
                hideToolbar={false}
                enablePublic
                template={editor}
                ReadOnly
                onMessageSubmit={handleNoteSubmission}
                module="NOTE"
                details={{
                  workItem: {
                    workId: props.project.projectId,
                    module: 'PROJECT'
                  }
                }}
                mode="feed"
                changeChatMode={() => toggleToolbar(null)}
                allowMentions
                attachmentUploadUrl={`${envConfig.fileRoot}/upload`}
                uploadParams={{
                  module: 'NOTE_ATTACHMENT',
                  details: JSON.stringify({
                    workItem: {
                      workId: props.project.projectId,
                      module: 'PROJECT'
                    }
                  })
                }}
                placeholder={getTranslatedText(
                  intl,
                  'project.details.feed.placeholder'
                )}
                scrollIntoView={scrollIntoView}
              />
            }
          />
        );
      case 'conversation':
        return (
          <AccessControl
            reference={projectContext.features}
            roleToCheck="comments.add"
            render={
              <ActionContainer
                hideToolbar={false}
                template={editor}
                ReadOnly
                project={{
                  ...props.project,
                  workId: props?.project?.projectId,
                  module: 'PROJECT'
                }}
                onMessageSubmit={handleCommentSubmission}
                module="PROJECT_COMMENT"
                details={{
                  operation: 'CREATE',
                  projectId: props.project.projectId
                }}
                mode="feed"
                changeChatMode={() => toggleToolbar(null)}
                allowMentions
                attachmentUploadUrl={`${envConfig.fileRoot}/upload`}
                uploadParams={{
                  module: 'PROJECT_CONVERSATION_ATTACHMENT',
                  details: JSON.stringify({
                    projectId: props.project.projectId
                  })
                }}
                placeholder={getTranslatedText(
                  intl,
                  'project.details.feed.placeholder'
                )}
                scrollIntoView={scrollIntoView}
              />
            }
          />
        );
      default:
        return (
          <ActionToolbar
            intl={intl}
            isEditAuthorised={isEditAuthorised}
            onClick={toggleToolbar}
            createNewSideConversation={props.createNewSideConversation}
          />
        );
    }

    // if (editMode) {
    //   return (
    //     <AccessControl
    //       reference={projectContext.features}
    //       roleToCheck="comments.add"
    //       render={
    //         <ActionContainer
    //           template={editor}
    //           ReadOnly
    //           onMessageSubmit={handleCommentSubmission}
    //           module="PROJECT_COMMENT"
    //           details={{
    //             operation: 'CREATE',
    //             projectId: props.project.projectId
    //           }}
    //           mode="feed"
    //           changeChatMode={toggleToolbar}
    //           allowMentions
    //           attachmentUploadUrl={`${envConfig.fileRoot}/upload`}
    //           uploadParams={{
    //             module: 'PROJECT_CONVERSATION_ATTACHMENT',
    //             details: JSON.stringify({ projectId: props.project.projectId })
    //           }}
    //           placeholder={getTranslatedText(
    //             intl,
    //             'project.details.feed.placeholder'
    //           )}
    //         />
    //       }
    //     />
    //   );
    // }
    // return (
    //   <ActionToolbar
    //     intl={intl}
    //     isEditAuthorised={isEditAuthorised}
    //     onClick={toggleToolbar}
    //     createNewSideConversation={props.createNewSideConversation}
    //   />
    // );
  };

  return (
    <FeedWrap ref={chatFeedRef} className="scroll relative full-height">
      {feeds.length > 0 ? (
        <ChatFeed
          ref={projectChatFeedRef}
          customChatBubble={(properties) => (
            <CustomBubble
              {...properties}
              switchToConnect={switchToConnect}
              {...props}
            />
          )}
          messages={feeds}
          authors={authors}
          yourAuthorId={user.userId}
        />
      ) : (
        <EmptyStateHolder className="scroll flex center jcenter">
          {getEmptyState()}
        </EmptyStateHolder>
      )}
      <ComposeSection />
    </FeedWrap>
  );
};

export default injectIntl(ProjectFeedsContainer);
